import * as React from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import './MonthCalendar.scss';
import { FunctionComponent, useEffect, useState } from 'react';
import { TFunction, useTranslation } from 'react-i18next';
import { prepareDateToString } from '../../utils/dateHelper';
import { eachWeekendOfMonth, getDaysInMonth, isEqual, isSameMonth, isWeekend } from 'date-fns';
import { NavigationButtons } from './NavigationButtons';
import { enUS } from 'date-fns/locale';
import { chooseEventTypeModalCall, deleteEventModalCall, editEventModalCall } from './CalendarPage';
import { SelectedDays, SpecialDay } from '../../types';
import { TableDataType } from '../../store/Calendar';
import { ReactComponent as WarningIcon } from '../../assets/icons/warning.svg';
import { Divider, Popover, Tooltip } from '@iba-team/portal-react-components/dist';
import interactionPlugin, { DateClickArg } from '@fullcalendar/interaction';
import { checkPastDate } from './FullCalendar';
import { observer } from 'mobx-react';
import { useCheckAccess, useDeviceSizeThreshold } from '../../utils/hooks';
import { BREAKPOINT_LG } from '../../consts';
import {ReactComponent as StarIcon} from '../../assets/icons/star.svg';
import { ReactComponent as WorkingIcon } from '../../assets/icons/reports/working-day.svg';
import {ReactComponent as CloseIcon} from '@iba-team/portal-react-components/dist/svg/outline/x.svg';
import { ReactComponent as DeleteIcon } from '@iba-team/portal-react-components/dist/svg/outline/trash.svg';
import { ReactComponent as EditIcon } from '@iba-team/portal-react-components/dist/svg/outline/edit.svg';
interface MonthCalendarI {
  tableData: TableDataType,
  activeTable: string,
  setActiveTable: (value: string) => void,
  setTableData: (value: TableDataType) => void
  dataSource: ReadonlyArray<SpecialDay>,
  setDataSource: (data: SpecialDay[])=> void,
}

interface RenderEventContentI {
  event: any,
  t: TFunction<'translation', string>,
  setDataSource: (data: SpecialDay[])=> void,
  dataSource: ReadonlyArray<SpecialDay>,
}

const RenderEventContent: FunctionComponent<RenderEventContentI> = (props) => {
  const {t} = useTranslation();
  const isTablet = useDeviceSizeThreshold(BREAKPOINT_LG);
  const {isAllowedAccess} = useCheckAccess('CALENDAR_ADMIN');
  const [current] = useState<SelectedDays>({
    from: props.event.date,
    to: props.event.date,
    title: props.event.title,
    description: props.event.description,
    type: props.event.dayType,
    id: props.event.id,
    isWeekend: props.event.isWeekend
  }
  );

  const [visible, setVisible] = useState(false);

  const prepareStartDate = prepareDateToString(enUS)(current.from);
  const prepareEndDate = prepareDateToString(enUS)(current.to);
  const isOneDayEvt = isEqual(current.from, new Date(current.to));

  // <TicketPopUp dataSource={props.dataSource} setDataSource={props.setDataSource} event={current} setOpen={() => console.log(20)} startKey={'from'} endKey={'to'} />;
  return (
    <Popover visible={visible} onOpenChange={() => setVisible(!visible)} className={'calendar_popover'} trigger={'click'} title={  <div className={'calendar_popover__title'}>
      <div className={'calendar_popover__title__left'}>
        {current.type === 'WORKING' ?
          <WorkingIcon/> :
          <StarIcon/>
        }
        <span>
          {current.title}
        </span>
      </div>
      <Tooltip title={t('close')}>
        <CloseIcon onClick={() => setVisible(false)} className={'close-icon'}/>
      </Tooltip>
    </div>} content={
      <div className={'calendar_popover__content'}>
        <div className={'calendar_popover__content__fields'}>
          <div className={'calendar_popover__content__fields__label'}>
            <span>
              {prepareStartDate('EEEE')}
            </span>
            {!isOneDayEvt &&
              <span style={{ paddingLeft: '5px' }}>
              - {prepareEndDate('EEEE')}
              </span>
            }
          </div>
          :
          <div className={'calendar_popover__content__fields__value'}>
            <span>{prepareStartDate('MMM')}</span>
            <span>{prepareStartDate('dd')}</span>
            {!isOneDayEvt &&
              <span>
                  - {prepareEndDate('dd')}
              </span>
            }
            ,
            <span> {prepareStartDate('yyyy')} </span>
          </div>
        </div>
        <div className={'calendar_popover__content__fields'}>
          <div className={'calendar_popover__content__fields__label'}>
            <span>{t('type')}:&nbsp;</span>
            {!isOneDayEvt &&
              <span style={{ paddingLeft: '5px' }}>
              - {prepareEndDate('EEEE')}
              </span>
            }
          </div>
          <div className={'calendar_popover__content__fields__value'}>
            <span>{t(current.type === 'HOLIDAY'
              ?
              'nonWorkingDay' : 'workingDay')}</span>
          </div>
        </div>
        {current.description &&
          <div className={'calendar_popover__content__fields'}>
            <div className={'calendar_popover__content__fields__label'}>
              <span>
                {t('modalFields_descr')}:&nbsp;
              </span>
            </div>
            <div  className={'calendar_popover__content__fields__value'}>
              <span>
                {current.description}
              </span>
            </div>
          </div>
        }
        {!isTablet && isAllowedAccess &&
          <>
            {!checkPastDate(current.from) &&
              <>
                <Divider/>
                <div className={'calendar_popover__content__footer'}>
                  <div className={'calendar_popover__content__footer__edit'}
                    onClick={() => {
                      editEventModalCall.showImmediately({
                        specialDays: {
                          dayType: current.type,
                          description: current.description,
                          endDate: current.from,
                          startDate: current.from,
                          title: current.title,
                          id: current.id,
                          isWeekend: current.isWeekend,
                        },
                        setDataSource: props.setDataSource,
                        dataSource: props.dataSource
                      }
                      );
                      setVisible(false);
                    }}>
                    <EditIcon/>
                    <span>{ t('edit') }</span>
                  </div>
                  <div className={'calendar_popover__content__footer__delete'}
                    onClick={() => {
                      deleteEventModalCall.showImmediately({specialDays: {
                        id: current.id, title: current.title, dayType: current.type
                      }, setDataSource: props.setDataSource, dataSource: props.dataSource });
                      setVisible(false);
                    }}>
                    <DeleteIcon/>
                    <span>{ t('delete') }</span>
                  </div>
                </div>
              </>
            }
          </>
        }
      </div>
    }>
      <div className={`eventWrapper ${props.event.dayType.toLowerCase()}`}>
        <div className={'titleWrapper'}>
          {props.event.dayType === 'HOLIDAY' ?
            <div className={'starWrapper'}>
              <StarIcon />
            </div>
            :
            <div className={'warningWrapper'}>
              <WarningIcon />
            </div>
          }
          <div className={'starTitle'}>
            {props.event.title}
          </div>
        </div>
      </div>

    </Popover>
  );
};

type SourceType = {
  title: string,
  date: Date,
  end: Date,
  id: string,
  startDate: string,
}
export const MonthCalendar = observer((props:MonthCalendarI) => {
  const { t } = useTranslation();
  const [events, setEvents] = useState<SourceType[]>([]);
  const {isAllowedAccess} = useCheckAccess('CALENDAR_ADMIN');
  const [currentMonth, setCurrentMonth] = useState(new Date());

  useEffect(() => {
    const prepareSource: SourceType[] = [];
    props.dataSource.forEach(item => {
      prepareSource.push({
        ...item,
        date: new Date(item.startDate),
        id: item.id.toString(),
        end: new Date(item.endDate),
        startDate: item.startDate.toString(),
      });
    });

    setEvents(prepareSource);
  }, [props.tableData, props.dataSource]);

  useEffect(() =>{
    props.setTableData({date: new Date(currentMonth)});
  }, [currentMonth]);

  const handleDateClick = (arg: DateClickArg) => {
    arg.jsEvent.preventDefault();
    if(!events.find(item=> item.startDate === arg.dateStr) && !checkPastDate(arg.date)){
      isAllowedAccess && chooseEventTypeModalCall.showImmediately({specialDays: {startDate: arg.date}, setDataSource: props.setDataSource, dataSource: props.dataSource});
    }
  };

  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <FullCalendar
      plugins={[dayGridPlugin, interactionPlugin]}
      customButtons={{
        workDays: {
          text: <div className={'custom-days'}>(
            {
              getDaysInMonth(currentMonth) - eachWeekendOfMonth(currentMonth).length -
              props.dataSource.filter(i =>
                isSameMonth(new Date(i.startDate), currentMonth) &&
                !isWeekend(new Date(i.startDate)) &&
                i.dayType !== 'WORKING').length
              + props.dataSource.filter(i => isSameMonth(new Date(i.startDate), currentMonth) && i.dayType === 'WORKING' && isWeekend(new Date(i.startDate))).length
            } working days)</div>
        },
        nav: {
          hint: ' ',
          text: <NavigationButtons dataSource={props.dataSource} setDataSource={props.setDataSource} activeTable={props.activeTable} setActiveTable={props.setActiveTable} />
        }
      }}
      firstDay={1}
      initialView={'dayGridMonth'}
      eventContent={(event) => {
        const current = events.find(item=> item.id === event.event.id);
        return  <RenderEventContent dataSource={props.dataSource} setDataSource={props.setDataSource} event={current} t={t} />;
      }}
      dateClick={handleDateClick}
      aspectRatio={2}
      events={events}
      initialDate={props.tableData.date}
      headerToolbar={{
        left: 'today prev,next title workDays',
        right: 'nav'
      }}
      fixedWeekCount={false}
      datesSet={(arg) => setCurrentMonth(arg.view.currentStart)}
    />
  );
});
